(() => {
  let scriptLoaded = false;
  let lastConsent = '';

  window.clarity = window.clarity || function() {
    (window.clarity.q = window.clarity.q || []).push(arguments);
  };

  const syncConsent = (event) => {
    const privacy = window.Shopify?.customerPrivacy;
    const choices = event?.detail;
    const analyticsAllowed = typeof choices?.analyticsAllowed === 'boolean'
      ? choices.analyticsAllowed
      : privacy?.analyticsProcessingAllowed?.() === true;
    const marketingAllowed = typeof choices?.marketingAllowed === 'boolean'
      ? choices.marketingAllowed
      : privacy?.marketingAllowed?.() === true;
    const saleOfDataAllowed = typeof choices?.saleOfDataAllowed === 'boolean'
      ? choices.saleOfDataAllowed
      : privacy?.saleOfDataAllowed?.() !== false;
    const consent = {
      analytics_Storage: analyticsAllowed ? 'granted' : 'denied',
      ad_Storage: marketingAllowed && saleOfDataAllowed ? 'granted' : 'denied'
    };
    const signature = JSON.stringify(consent);

    if (signature !== lastConsent) {
      window.clarity('consentv2', consent);
      lastConsent = signature;
    }

    if (!scriptLoaded) {
      scriptLoaded = true;
      const script = document.createElement('script');
      script.async = true;
      script.src = 'https://www.clarity.ms/tag/qxy7y2vqdq';
      document.head.appendChild(script);
    }
  };

  document.addEventListener('visitorConsentCollected', syncConsent);

  if (window.Shopify?.customerPrivacy?.analyticsProcessingAllowed) {
    syncConsent();
  }
  else if (window.Shopify?.loadFeatures) {
    window.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.2' }], syncConsent);
  }
  else {
    syncConsent();
  }
})();
